export default function (config, answer) {
  const entity = config.entities.find(e => e.guid === answer);
  return {
    correct: Boolean(entity),
    name: entity ? entity.name : "error",
  };
}
